export const DOWNLOAD_RESULT_PDF_FILE_SUCCESS = 'DOWNLOAD_RESULT_PDF_FILE_SUCCESS';

export const downloadResultPdfFileSuccess = result => ({
    type: DOWNLOAD_RESULT_PDF_FILE_SUCCESS,
    payload: { result },
});
